export default __webpack_public_path__ + "static/media/search.a0c59389.svg";